<div class="reporting-stations-dashboard">
  <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
    
    <div class="menu widget-menu-layer-1">
      <span class="item" (click)="back()"><sc-icon iconClass="fa-chevron-left"></sc-icon></span>
      <span class="item">{{selectedDate | date: 'dd.MM.yyyy'}}</span>
      <span class="item" (click)="forward()"><sc-icon iconClass="fa-chevron-right"></sc-icon></span>
      <span class="item margin-left-25" [ngClass]="{'selected': isShowDailyMode()}" (click)="showDailyMode()">{{'daily' |
        translate: ['reporting.station-occupancy.mode.daily', translationService.language]}}</span>
      <span class="item" [ngClass]="{'selected': isShowHourlyMode()}" (click)="showHourlyMode()">{{'hourly' | translate:
        ['reporting.station-occupancy.mode.hourly', translationService.language]}}</span>
      <ng-container *ngIf="isShowHourlyMode()">
        <button class="item margin-left-25" mat-stroked-button (click)="printHourlyReport()">
          {{'print' |translate:['reporting.station-occupancy.action.print-hourly', translationService.language]}}
        </button>
      </ng-container>
    </div>

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <sc-flex-fitting-content [vertical]="true">
      <app-stacked-bar-chart [data]="data.chart" *ngIf="isShowDailyMode() && data != null"></app-stacked-bar-chart>
      <ng-container *ngIf="isShowHourlyMode() && data != null && this.data.chartSvg">
        <sc-padding [fitHeight]="true">
          <div class="svg-chart" [innerHtml]="this.data.chartSvg | trustHtml" *ngIf="isShowHourlyMode()"></div>
        </sc-padding>
      </ng-container>
    </sc-flex-fitting-content>

  </sc-flex>

</div>